import React from 'react'
import { Flex, Box, SystemProps, Icon } from '@storyofams/react-ui'
import { defineMessages, useIntl } from 'react-intl'
import { Heading, Text, Button } from '~components'
// import { SummaryProductCard } from './SummaryProductCard'
import { SummaryVariantCard } from './SummaryVariantCard'
import { CartThin } from '~components/common/Icons'

const messages = defineMessages({
  yourOrder: 'Your order',
  product: 'Product',
  quantity: 'Quantity',
  price: 'Price',
  goShopping: 'Go Shopping',
  bagIsEmpty: 'Your bag is empty',
})

export const SummaryPopupContent = ({
  cartItemsIds,
  setCartOpen,
}: {
  cartItemsIds?: any
  setCartOpen: Function
} & SystemProps) => {
  const intl = useIntl()

  return (
    <>
      <Box width="100%" bg="white" borderRadius={'8px 8px 0px 0px'}>
        <Flex flexDirection={'column'} py={[1.5, 2.5]} px={[1.5, 2.5]}>
          <Flex justifyContent="space-between" pb={[0.5, 1]}>
            <Heading variant="sh3" as="h5" fontWeight="900">
              {intl.formatMessage(messages.yourOrder)}
            </Heading>
            <button onClick={() => setCartOpen(false)}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6L6 18"
                  stroke="#1B1819"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 6L18 18"
                  stroke="#1B1819"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </Flex>
          <Flex
            flexDirection={'column'}
            maxHeight={{ all: '60vh', md: '70vh' }}
            overflowY={cartItemsIds.length == 1 ? 'visible' : 'auto'}
          >
            {!!cartItemsIds && cartItemsIds.length > 0 ? (
              <>
                <Box display={{ all: 'none', md: 'block' }}>
                  <Flex>
                    <Box width={'calc(25% + 84px)'} pl={4}>
                      <Text pl={1.25}>
                        {intl.formatMessage(messages.product)}
                      </Text>
                    </Box>
                    <Box width={'25%'} textAlign={'center'}>
                      <Text></Text>
                    </Box>
                    <Box width={'25%'} textAlign={'center'}>
                      <Text>{intl.formatMessage(messages.quantity)}</Text>
                    </Box>
                    <Box width={'25%'} pr={4} textAlign={'right'}>
                      <Text pr={1.25}>
                        {intl.formatMessage(messages.price)}
                      </Text>
                    </Box>
                  </Flex>
                </Box>
                {cartItemsIds.map((cartItemId, index) => (
                  <SummaryVariantCard
                    cartItemId={cartItemId}
                    isLastItems={index + 1 == cartItemsIds.length}
                  />
                ))}
              </>
            ) : (
              <Flex
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                height="100%"
                py={2}
              >
                <Icon icon={CartThin} fontSize={10} mb={5} />
                <Text fontWeight="bold" fontSize={2.25} mb={2}>
                  {intl.formatMessage(messages.bagIsEmpty)}
                </Text>
                <Button
                  variant="primary"
                  onClick={() => {
                    setCartOpen(false)
                  }}
                >
                  {intl.formatMessage(messages.goShopping)}
                </Button>
              </Flex>
            )}
            {/* {productIds.map((productId, index) => (
              <SummaryProductCard productId={productId} isLastItems={(index + 1) == productIds.length} />
            ))} */}
          </Flex>
        </Flex>
      </Box>
      <Box
        style={{
          marginLeft: '-10px',
          padding: '10px',
          paddingBottom: '0',
          overflow: 'hidden',
          position: 'absolute',
          height: 'calc(100% + 10px)',
          width: 'calc(100% + 20px)',
          bottom: '0',
          zIndex: -1,
        }}
      >
        <Box
          width="100%"
          height="100%"
          bg="transparent"
          borderRadius={'8px 8px 0px 0px'}
          boxShadow={'0px 5px 12px rgba(0, 0, 0, 0.25)'}
        ></Box>
      </Box>
    </>
  )
}
